"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsIndication = void 0;
const moment = require("moment");
const good_news_words_data_1 = require("./data/good-news-words.data");
const bad_news_words_data_1 = require("./data/bad-news-words.data");
const news_sentiment_enum_1 = require("../../@types/outcoming/enum/news-sentiment.enum");
class NewsIndication {
    getIndication(newsData) {
        let qntGoodWords = 0;
        let qntBadWords = 0;
        let qntValidNews = 0;
        let sentiment = news_sentiment_enum_1.eNewsSentiment.NEUTRAL;
        newsData.forEach((newsItem) => {
            const age = this.getNewsAgeInDays(newsItem.dateTimestamp);
            if (age < 30) {
                const title = newsItem.name;
                good_news_words_data_1.goodNewsWordsData.forEach((word) => {
                    if (title.includes(word)) {
                        qntGoodWords++;
                    }
                });
                bad_news_words_data_1.badNewsWordsData.forEach((word) => {
                    if (title.includes(word)) {
                        qntBadWords++;
                    }
                });
                qntValidNews++;
            }
        });
        if (qntGoodWords > qntBadWords) {
            sentiment = news_sentiment_enum_1.eNewsSentiment.BUY;
        }
        else if (qntBadWords > qntGoodWords) {
            sentiment = news_sentiment_enum_1.eNewsSentiment.SELL;
        }
        return {
            qntGoodNews: qntGoodWords,
            qntBadNews: qntBadWords,
            qntNews: qntValidNews + 12,
            sentiment,
            internalPoints: this.getInternalPoints(sentiment),
        };
    }
    getNewsAgeInDays(timestamp) {
        const newsPublishedAt = moment.unix(timestamp);
        return moment().diff(newsPublishedAt, 'd');
    }
    getInternalPoints(sentiment) {
        switch (sentiment) {
            case news_sentiment_enum_1.eNewsSentiment.BUY:
                return 1;
            case news_sentiment_enum_1.eNewsSentiment.SELL:
                return -1;
        }
        return news_sentiment_enum_1.eNewsSentiment.NEUTRAL;
    }
}
exports.NewsIndication = NewsIndication;
//# sourceMappingURL=news-indication.js.map